import React from "react";
import { Divider, Skeleton, Stack } from "@mui/material";

import { HubDialogTitle, InputSkeleton } from "../../../components";
import { StyledFormStack, StyledSideStack } from "../styles";
import ShipmentItemTableSkeleton from "./ShipmentItemTableSkeleton";
import { ShippingTitleLabel } from "../ShipmentDetailsDialogTitle";

export const ShipmentDetailsSkeleton = ({ returning }) => {
  return (
    <Stack sx={{ height: "calc(100vh - 50px)" }}>
      <HubDialogTitle leftContent={<ShippingTitleLabel />} />
      <StyledFormStack>
        <StyledSideStack height="calc(100vh - 125px)" overflow="scroll">
          <Stack gap="10px">
            <Skeleton height="18px" variant="rounded" />
            <Stack gap="15px">
              <InputSkeleton />
              {returning && <InputSkeleton />}
            </Stack>
          </Stack>

          <ShipmentItemTableSkeleton />
          <ShipmentItemTableSkeleton />
        </StyledSideStack>
        <StyledSideStack dark="true">
          <InputSkeleton inputHeight="44px" />
          <InputSkeleton />
          <InputSkeleton />
          <InputSkeleton inputHeight="100px" />
          <Divider orientation="horizontal" flexItem />
          <Stack gap="25px">
            <InputSkeleton inputHeight="20px" gap="2px" />
            <InputSkeleton inputHeight="20px" gap="2px" />
          </Stack>
        </StyledSideStack>
      </StyledFormStack>
    </Stack>
  );
};

export default ShipmentDetailsSkeleton;
